/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.
import '@angular/localize/init';
import 'classlist.js';
import "core-js/stable";
import 'web-animations-js';
